<template>
  <div div class="animated fadeIn">
    <b-modal ref="modalFile" size="xl" hide-footer :title="titleModal">
      <img :src="showImage"  :alt="objSelected.arquivoNome" v-show="imagePath && !isPdf" style="width:100%;">
      <iframe v-show="isPdf"
        style="overflow: hidden"
        id="pdfViewer"
        scrolling="no"
        height="500vh"
        class="mb-2 pdf-overview"
        :src="'data:application/pdf;base64,'+ showImage+ '#toolbar=0&navpanes=0&scrollbar=0'" frameborder="0">
      </iframe>
    </b-modal>
  </div>
</template>
<script>
import { loading } from '@/shared/utils/UIHelper'
import ExpenseItemRepository from '@/shared/http/repositories/business/expenseitem.js'

export default {
  name: 'ModalShowFile',
  data () {
    return {
      objSelected: null,
      imagePath: null,
      isPdf: false
    }
  },
  computed: {
    titleModal: function () {
      let result = 'VISUALIZAÇÃO DE ANXO'
      if (this.objSelected) {
        result = 'VISUALIZAÇÃO DE ANXO - ' + this.objSelected.arquivoNome
      }
      return result
    },
    showImage: function () {
      let result = ''
      if (this.imagePath) {
        result = this.imagePath
      }
      return result
    }
  },
  methods: {
    showModal (obj) {
      this.imagePath = null
      this.isPdf = obj.arquivoNome.includes('.pdf')
      this.objSelected = obj
      this.$refs['modalFile'].show()
      this.onRequestImage(obj)
    },
    hideModal () {
      this.$refs['modalFile'].hide()
    },
    getPathAttach (obj) {
      let result = ''
      if (obj) {
        const basePath = 'https://files.zsistema.zopone.com.br/'
        result = basePath + obj.arquivoPath + '/' + obj.arquivoNome
        console.log(result)
        console.log('Obj->', obj)
      }
      return result
    },
    onRequestImage (obj) {
      loading.push()
      ExpenseItemRepository.GetAttached(obj.id)
        .then((response) => {
          if (response.data.code === 200) {
            let imgByte = response.data.data
            if (!this.isPdf) {
              this.imagePath = 'data:image/png;base64,' + imgByte
            } else {
              this.imagePath = imgByte
            }
          }
          console.log(response)
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    }
  }
}
</script>
<style scoped>
#pdfViewer{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelrefund/details/components/modal/attach/modalShowFile.vue